import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-star',
  standalone: true,
  templateUrl: '../../assets/star.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamStarIcon {}
